export default __webpack_public_path__ + "static/media/Thales.d5b873e7.png";